__turbopack_context__.v({
  "divider": "RecentSearch-module-scss-module__jEGCYG__divider",
  "label": "RecentSearch-module-scss-module__jEGCYG__label",
  "list": "RecentSearch-module-scss-module__jEGCYG__list",
  "removeButton": "RecentSearch-module-scss-module__jEGCYG__removeButton",
  "root": "RecentSearch-module-scss-module__jEGCYG__root",
  "searchItem": "RecentSearch-module-scss-module__jEGCYG__searchItem",
  "searchItemText": "RecentSearch-module-scss-module__jEGCYG__searchItemText",
});
